import config  from "@/config";
const url = config.url;
const urls = {          
    showCategoryList:url + '/category/showCategoryList',                             //首页科室列表
    showLabelList:url + '/label/showLabelList',                                      //搜索 
    showInformationList:url + '/information/showInformationList',                    // 科室列表
    getInformation:url + '/information/getInformation',                              // 资讯详情（视频详情）   
    getUserinfo:url + '/user/getUserinfo',                                           // 基本信息
    getMyDoctors:url + '/user/getMyDoctors',                                         // 我邀请的用户
    getMyDoctorUserinfo:url + '/user/getMyDoctorUserinfo',                           // 医生详情
    getMyDownload:url + '/information/getMyDownload',                                // 我的下载
    getPeopleInfo:url + '/user/getUserinfo',                                         // 个人基本信息
    updateUserinfo:url + '/user/updateUserinfo',                                     // 修改用户基本信息
    getMyAttention:url + '/information/getMyAttention',                              // 个人中心 我的关注
    hasAttention:url + '/information/hasAttention',                                   // 是否关注
    doAttention:url + '/information/doAttention',                                     // 关注
    cancelAttention:url + '/information/cancelAttention',                             // 取消关注
    doDownload:url + '/information/doDownload',                                       // 资讯下载
    getDefaultEmail:url + '/information/getDefaultEmail',                             // 获取默邮箱
    getQuestionnaire:url +'/information/getQuestionnaire',                            // 获取调研问卷       
    submitQuestionnaire:url + '/information/submitQuestionnaire'                      // 提交调研问卷结果  
}
import * as mUtils from "@/config/mUtils.js";
import axios from 'axios';
import Qs from 'qs';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

var jsonToken = (params) => {
    let token = {token:mUtils.getStore('token')};
	// let ps = Object.assign(token, params);
    return Qs.stringify(Object.assign(token, params));
}

//首页科室列表
export const showCategoryList = (params = {}) => {
    let QsParams = jsonToken(params);
    return axios.post(urls.showCategoryList,QsParams).catch(getError);
}

// 搜索列表
export const showLabelList = (params = {}) => { 
    let QsParams = jsonToken(params);
    return axios.post(urls.showLabelList,QsParams).catch(getError);
}

// 各科室资讯列表
export const showInformationList = (params = {}) => {
    let QsParams = jsonToken(params);
    return axios.post(urls.showInformationList,QsParams).catch(getError);
}

//视频详情
export const getInformation = (params = {}) => {
    let q = {
        informationId:params
    }
    let QsParams = jsonToken(q);
    return axios.post(urls.getInformation,QsParams).catch(getError);
}

// 个人中心
// 1基本信息
export const getUserinfo = (params = {}) => {
    let q = {}
    let QsParams = jsonToken(q);
    return axios.post(urls.getUserinfo,QsParams).catch(getError);
}

// 2我的关注
export const getMyAttention = (params = {}) => {
    let q = {};
    let QsParams = jsonToken(q);
     return axios.post(urls.getMyAttention,QsParams).catch(getError);
}

// 3我的下载
export const getMyDownload = (params = {}) => {
    let q = {};
    let QsParams =jsonToken(q);
    return axios.post(urls.getMyDownload,QsParams).catch(getError)
}

// 4 我的医生
export const getMyDoctors = (params = {}) => { 
    let QsParams = jsonToken(params); 
    return axios.post(urls.getMyDoctors,QsParams).catch(getError)
}

// 4-2我的关注里面的医生详情
export const getMyDoctorUserinfo = (params = {}) => {
    let q = {
        userId:params
    }
    let QsParams = jsonToken(q);
    return axios.post(urls.getMyDoctorUserinfo,QsParams).catch(getError)
}

// 4 我的医生 --医生信息
export const getMyDoctor = (params = {}) => { 
    let QsParams = jsonToken(params);
    return axios.post(urls.getUserinfo,QsParams).catch(getError)
}

// 修改用户基本信息
export const updateUserinfo = (params = {}) => { 
    let QsParams = jsonToken(params);
    return axios.post(urls.updateUserinfo,QsParams).catch(getError)
}

// 获取个人基本信息
export const getPeopleInfo = (params={}) => {
	return axios.post(urls.getPeopleInfo,params).catch(getError)
}

// code 
export const getCodeId = (path = {}) => {
    //alert('我传给第三方的地址是:'+path);
    //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc05594ce9923d91c&redirect_uri=http%3a%2f%2fwww.imedunion.com%2findex1.html&response_type=code&scope=snsapi_userinfo&state='+encodeURIComponent(path)+'#wechat_redirect'
    return new Promise(function(resolve, reject){
        setTimeout(function(){
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc05594ce9923d91c&redirect_uri=http%3A%2F%2Fwww.imedunion.com&response_type=code&scope=snsapi_userinfo&state='+encodeURIComponent(path)+'#wechat_redirect'
        },0);
        resolve('');
    });

}

// 获取 openid
export const getOpenId = async (params='') => {
    let q;
    if(mUtils.isWeixinBrowser()){
        q = {
            code:params
        }    
    }else{
        q = {
            code:params,
            from:"PC"
        }
    }
    let QsParams = jsonToken(q);
    return axios.post('http://www.imedunion.com/islide/thirdLogin/wxLogin',QsParams).then((res) => { 
        if(res.status == 200){
            return res.data 
        }
    }).catch(getError)
}
 
// 是否关注
export const hasAttention = async (params = {}) => {
    let QsParams = jsonToken(params);
    return axios.post(urls.hasAttention,QsParams).catch(getError)
}

// 资讯关注
export const doAttention = async (params = {}) => {
    let QsParams = jsonToken(params);
    return axios.post(urls.doAttention,QsParams).catch(getError)
}
// 取消关注
export const cancelAttention = async (params = {}) => {
    let QsParams = jsonToken(params);
    return axios.post(urls.cancelAttention,QsParams).catch(getError)
}
// 获取默认邮箱
export const getDefaultEmail = async (params = {}) => {
    let QsParams = jsonToken(params);
    return axios.post(urls.getDefaultEmail,QsParams).catch(getError);
}
// 资讯下载
export const doDownload = async (params = {}) => { 
    let QsParams = jsonToken(params);
    return axios.post(urls.doDownload,QsParams).catch(getError);
}

// 获取调研问卷
export const getQuestionnaire = async(params = {}) => {
    let QsParams = jsonToken(params);
    return axios.post(urls.getQuestionnaire,QsParams).catch(getError)
}
//提交调研问卷结果
export const submitQuestionnaire = async(params = {}) => {
    let QsParams = jsonToken(params);
    return axios.post(urls.submitQuestionnaire,QsParams).catch(getError) 
}

// 请求位置错误提示
var getError = (err) => {
	// console.log('错误提示:',err.response); 
    console.log(err.response)
    return 0;
}




// WEBPACK FOOTER //
// ./src/service/getData.js